import { Subscribable } from 'knockout';
import { IWCCStorageManager } from 'managers/iStorage';
import WCCAttachment from 'models/attachments/attachment';
import pattern from 'patterns/attachments';
import { WCCContentAttachmentsBlock } from '../blocks/attachments/attachments';
import WCCContentContext, { IWCCContentContext } from '../context';
import WCCContentDocument from '../document';
import WCCContentPatternRule from './pattern';

function isVideoBlock(ids: Array<string>) {
    return ids.length === 1 && ids[0].indexOf('.mp4') !== -1;
}

export class WCCContentAttachmentsRuleContext implements IWCCContentContext {
    takenVideos = new Array<WCCAttachment>();

    storage: IWCCStorageManager    
    topicId: Subscribable<string | undefined>

    constructor(context: WCCContentContext) {
        this.storage = context.storage;
        this.topicId = context.topicId;
    }
}

export default class WCCContentAttachmentsRule extends WCCContentPatternRule {
    protected pattern = pattern;

    constructor(protected attachments: Subscribable<Array<WCCAttachment>>) {
        super();
    }

    override parse(document: WCCContentDocument, context: WCCContentContext) {
        return super.parse(document, new WCCContentAttachmentsRuleContext(context));
    }

    protected process(match: RegExpMatchArray, context: WCCContentAttachmentsRuleContext) {
        const [content, idsStr] = match;

        const ids = idsStr.split(';').map(id => this.decode(id.toLowerCase()));
        const attachments = this.getObservableAttachments(this.attachments, ids, context);

        return new WCCContentAttachmentsBlock({ content, attachments });
    };

    protected getObservableAttachmentsCommon(attachments: Subscribable<Array<WCCAttachment>>, ids: Array<string>) {
        return attachments.filter(attachment => {
            const fileId = (attachment.userFileId() || '').toLowerCase();
            const contentId = attachment.contentId();

            return ids.some(id => id === contentId || id === fileId);
        });
    }

    protected decode(str: string) {
        return decodeURI(decodeURI(str));
    }

    protected getObservableAttachments(attachments: Subscribable<Array<WCCAttachment>>, ids: Array<string>, context: WCCContentAttachmentsRuleContext) {
        if (isVideoBlock(ids))
            return this.getObservableVideoAttachments(attachments, ids[0], <Array<WCCAttachment>>context.takenVideos);
        else
            return this.getObservableAttachmentsCommon(attachments, ids);
    }

    protected getObservableVideoAttachments(attachments: Subscribable<Array<WCCAttachment>>, id: string, takenVideos: Array<WCCAttachment>) {
        return ko.pureComputed(() => {
            const videoAttachments = attachments().filter(attachment => attachment.isVideo());
            let attachment = videoAttachments.find(attachment => attachment.contentId() == id);

            if (attachment == undefined)
                attachment = videoAttachments.find(attachment => {
                    const link = this.decode((attachment.originalLink() || attachment.link() || '').toLowerCase());

                    return id === link;
                });

            if (attachment == undefined)
                attachment = _(videoAttachments).difference(takenVideos)[0];

            if (attachment != undefined) {
                takenVideos.push(attachment);
                return [attachment];
            }

            return [];
        });
    }
}